import EditableResult from '../../../components/EditableResult';
import EditableResultSwitch from '../../../components/EditableResultSwitch';
import { useState, useEffect } from 'react';
import { createHighlight, getHighlight, updateHighlight } from '../../../apis/Ambition';
import edit from '../../../assets/shapes_svg/roledetail/edit.svg';
import { useTranslation } from 'react-i18next';
import '../index.css';
import './index.css';
import { Textareawithsteroids3 } from '../EUGreenDeal/EUGreenDeal';

const CompanyEmissions = () => {
    const { t } = useTranslation();

    const [ghgRequirements, setGhgRequirements] = useState(false)
    const [scopeOperation1, setScopeOperation1] = useState("")
    const [scopeOperation2, setScopeOperation2] = useState("")

    const [reportScopes, setReportScopes] = useState(false)
    const [emissionScope1, setEmissionScope1] = useState("")
    const [baseYearScope1, setBaseYearScope1] = useState("")
    const [emissionScope2, setEmissionScope2] = useState("")
    const [baseYearScope2, setBaseYearScope2] = useState("")
    const [greenCert, setGreenCert] = useState(false)

    const [accountability, setAccountability] = useState(false)
    const [sbtiConfirm, setSbtiConfirm] = useState(false)

    const [editGhgRequirements, setEditGhgRequirements] = useState(false)
    const [editScopeOperation1, setEditScopeOperation1] = useState(false)
    const [editScopeOperation2, setEditScopeOperation2] = useState(false)
    const [editReportScopes, setEditReportScopes] = useState(false)
    const [editEmissionScope1, setEditEmissionScope1] = useState(false)
    const [editBaseYearScope1, setEditBaseYearScope1] = useState(false)
    const [editEmissionScope2, setEditEmissionScope2] = useState(false)
    const [editBaseYearScope2, setEditBaseYearScope2] = useState(false)
    const [editGreenCert, setEditGreenCert] = useState(false)
    const [editAccountability, setEditAccountability] = useState(false)
    const [editSbtiConfirm, setEditSbtiConfirm] = useState(false)

    const fields = [
        {'name':'ghgrequirementssbti','setValue':setGhgRequirements,'edit':editGhgRequirements,'value':ghgRequirements},
        {'name':'reportscopessbti','setValue':setReportScopes,'edit':editReportScopes,'value':reportScopes},
        {'name':'greencertsbti','setValue':setGreenCert,'edit':editGreenCert,'value':greenCert},
        {'name':'accountabilitysbti','setValue':setAccountability,'edit':editAccountability,'value':accountability},
        {'name':'sbticonfirm','setValue':setSbtiConfirm,'edit':editSbtiConfirm,'value':sbtiConfirm},
    ]
    
    const updateField = ({action='update', valueName, value}) => {
        if(action !== 'update'){
            createHighlight({key:valueName,value:value})
        }
        else{
            updateHighlight({
                key:valueName,
                value:value,
                swal:false
            })
        }    
    }

    useEffect(() => {
        fields.map((field) => {
            getHighlight({
                key:field.name,
                setValue:field.setValue
            })
            
        })
    }, []) 

    useEffect(() => {
        fields.map((field) => {
            if(field.edit){
                updateField({
                    valueName:field.name, 
                    value:field.value,
                })
            }
        })
    }, [ghgRequirements, reportScopes, greenCert, accountability, sbtiConfirm])

    const def = <>It is required that your company will follow the GHG Protocol Corporate Standard and Scope 2 Guidance to estimate and report GHG emissions and will follow the guidelines for inventory recalculation.<br/><br/>
    The YFS web app is following the latest guidelines and standards from the GHG Protocol, hence are and will all calculations be in accordance with the validation requirements.
    </>;

    const def2 = <>Reporting on scope 1 and 2 are as you probably have experienced a long, complex and iterative process. According to the sbti your company must not exclude from the GHG inventory more than 5% of scope 1 and 2 emissions combined. With this statement sbti wish to stress the importance of accurate and adequate data.</>;

    const def3 = <>In the YFS web app we do not use offsets or avoided emissions as progress toward achieving CO2 reduction.*
    (Insert tick-off-box) By ticking off this box, you are confirming that you are following the SBTi validation requirements
    </>;

    const def4 = <>In order to become part of the SBTi, your company are required to publicly report on your emissions and progress against targets annually. *</>;

    const greenCertYes = <>Based on this information we can tell you, that YFS framework has used a combination of the Marked-based method and the location-based method to report your scope 2 emissions.
    </>

    const greenCertNo = <>Based on this information we can tell you, that YFS framework has used the location-based method to report your scope 2 emissions.
    </>

    return (
        <>
            <h5 style={{textAlign:"center"}}>{def}</h5>
            <div className="sbti__fields">
                <div className="sbti__labels">
                    Confirm to have followed the GHG requirements and filled in all known data in the YFS company tab
                </div>
                <div className="sbti__inputs">
                    { editGhgRequirements ?
                    <EditableResultSwitch
                        result={ghgRequirements}
                        edit={true}
                        changeTo={ghgRequirements}
                        setValue={setGhgRequirements}
                        choice1={'Yes'}
                        choice2={'No'}
                        autosave={true}
                        styleNo={1}
                    />
                    : <h5 style={{textAlign:"center"}}>{ghgRequirements}</h5>
                    }
                </div>
                <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditGhgRequirements(!editGhgRequirements)}/>
            </div>
            <div className="sbti__fields">
                <div className="sbti__labels">
                    Describe the primary operations and activities that account for emissions in scopes 1 and 2.*
                </div>
                <div style={{display:"flex",flexDirection:"column", width:"47%"}}>
                    <div style={{display:"flex",flexDirection:"row"}}>
                        <div className="sbti__inputs" style={{width:"100%"}}>
                            { editScopeOperation1 ?
                            <Textareawithsteroids3 maxLength={50} keyHighlight={'scope_1_operation'} placeholder="Scope 1"/>
                            : <Textareawithsteroids3 maxLength={50} keyHighlight={'scope_1_operation'} disabled={true} placeholder="Scope 1" />
                            }
                        </div>
                        <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditScopeOperation1(!editScopeOperation1)}/>
                    </div>
                    <div style={{display:"flex",flexDirection:"row"}}>
                        <div className="sbti__inputs" style={{width:"100%"}}>
                        { editScopeOperation2 ?
                            <Textareawithsteroids3 maxLength={50} keyHighlight={'scope_2_operation'} placeholder="Scope 2"/>
                            : <Textareawithsteroids3 maxLength={50} keyHighlight={'scope_2_operation'} disabled={true} placeholder="Scope 2" />
                            }
                        </div>
                        <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditScopeOperation2(!editScopeOperation2)}/>
                    </div>
                </div>
            </div>
            <br/><br/>
            <h5 style={{textAlign:"center"}}>{def2}</h5>
            <div className="sbti__fields">
                <div className="sbti__labels">
                    Confirm that you have reported on all scope 1 and 2 emissions (only with a 5% buffer)
                </div>
                <div className="sbti__inputs">
                    { editReportScopes ?
                    <EditableResultSwitch
                        result={reportScopes}
                        edit={true}
                        changeTo={reportScopes}
                        setValue={setReportScopes}
                        choice1={'Yes'}
                        choice2={'No'}
                        autosave={true}
                        styleNo={1}
                    />
                    : <h5 style={{textAlign:"center"}}>{reportScopes}</h5>
                    }
                </div>
                <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditReportScopes(!editReportScopes)}/>
            </div>
            <div className="sbti__fields">
                <div className="sbti__labels">
                    Base year scope 1 emissions
                </div>
                <div style={{display:"flex",flexDirection:"column", width:"47%"}}>
                    <div style={{display:"flex",flexDirection:"row"}}>
                        <div className="sbti__inputs" style={{width:"100%"}}>
                            { editEmissionScope1 ?
                            <Textareawithsteroids3 maxLength={50} keyHighlight={'emission_scope_1'} placeholder="tCO2e"/>
                            : <Textareawithsteroids3 maxLength={50} keyHighlight={'emission_scope_1'} disabled={true} placeholder="tCO2e" />
                            }
                        </div>
                        <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditEmissionScope1(!editEmissionScope1)}/>
                    </div>
                    <div style={{display:"flex",flexDirection:"row"}}>
                        <div className="sbti__inputs" style={{width:"100%"}}>
                        { editBaseYearScope1 ?
                            <Textareawithsteroids3 maxLength={50} keyHighlight={'base_year_scope_1'} placeholder="in (insert base year)"/>
                            : <Textareawithsteroids3 maxLength={50} keyHighlight={'base_year_scope_1'} disabled={true} placeholder="in (insert base year)" />
                            }
                        </div>
                        <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditBaseYearScope1(!editBaseYearScope1)}/>
                    </div>
                </div>
            </div>
            <div className="sbti__fields">
                <div className="sbti__labels">
                    Base year scope 2 emissions
                </div>
                <div style={{display:"flex",flexDirection:"column", width:"47%"}}>
                    <div style={{display:"flex",flexDirection:"row"}}>
                        <div className="sbti__inputs" style={{width:"100%"}}>
                            { editEmissionScope2 ?
                            <Textareawithsteroids3 maxLength={50} keyHighlight={'emission_scope_1'} placeholder="tCO2e"/>
                            : <Textareawithsteroids3 maxLength={50} keyHighlight={'emission_scope_1'} disabled={true} placeholder="tCO2e" />
                            }
                        </div>
                        <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditEmissionScope2(!editEmissionScope2)}/>
                    </div>
                    <div style={{display:"flex",flexDirection:"row"}}>
                        <div className="sbti__inputs" style={{width:"100%"}}>
                        { editBaseYearScope2 ?
                            <Textareawithsteroids3 maxLength={50} keyHighlight={'base_year_scope_2'} placeholder="in (insert base year)"/>
                            : <Textareawithsteroids3 maxLength={50} keyHighlight={'base_year_scope_2'} disabled={true} placeholder="in (insert base year)" />
                            }
                        </div>
                        <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditBaseYearScope2(!editBaseYearScope2)}/>
                    </div>
                </div>
            </div>
            <div className="sbti__fields">
                <div className="sbti__labels">
                    Have your company bought green certificates?
                </div>
                <div className="sbti__inputs">
                    { editGreenCert ?
                    <EditableResultSwitch
                        result={greenCert}
                        edit={true}
                        changeTo={greenCert}
                        setValue={setGreenCert}
                        choice1={'Yes'}
                        choice2={'No'}
                        autosave={true}
                        styleNo={1}
                    />
                    : <h5 style={{textAlign:"center"}}>{greenCert}</h5>
                    }
                    {greenCert === 'No' ? 
                    <h6 style={{textAlign:"center", margin:"10px"}}>{greenCertNo}</h6>
                    : <h6 style={{textAlign:"center", margin:"10px"}}>{greenCertYes}</h6>
                    }
                </div>
                <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditGreenCert(!editGreenCert)}/>
            </div>
            <br/><br/>
            <h5 style={{textAlign:"center"}}>{def3}</h5>
            <div className="sbti__fields">
                <div className="sbti__labels">
                    Confirm here that you agree to not having accounted for offsets or avoided emissions in your scope 1 and 2 reporting
                </div>
                <div className="sbti__inputs">
                    { editAccountability ?
                    <EditableResultSwitch
                        result={accountability}
                        edit={true}
                        changeTo={accountability}
                        setValue={setAccountability}
                        choice1={'Yes'}
                        choice2={'No'}
                        autosave={true}
                        styleNo={1}
                    />
                    : <h5 style={{textAlign:"center"}}>{accountability}</h5>
                    }
                </div>
                <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditAccountability(!editAccountability)}/>
            </div>
            <br/><br/>
            <h5 style={{textAlign:"center"}}>{def4}</h5>
            <div className="sbti__fields">
                <div className="sbti__labels">
                    Please confirm here that you will do so:
                </div>
                <div className="sbti__inputs">
                    { editSbtiConfirm ?
                    <EditableResultSwitch
                        result={sbtiConfirm}
                        edit={true}
                        changeTo={sbtiConfirm}
                        setValue={setSbtiConfirm}
                        choice1={'Yes'}
                        choice2={'No'}
                        autosave={true}
                        styleNo={1}
                    />
                    : <h5 style={{textAlign:"center"}}>{sbtiConfirm}</h5>
                    }
                </div>
                <img className="edit__icon" src={edit} alt="edit icon" onClick={() => setEditSbtiConfirm(!editSbtiConfirm)}/>
            </div>
        </>
    )
}

export default CompanyEmissions;